import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useMode from '@app/hooks/useMode';
import Mode from '@app/modes/Mode';
import { getSectionTitle } from '@app/domain/sections';
import { trackEvent } from './analytics';
import { EVENTS } from './events';

function fire(mode: Mode): void {
  trackEvent({
    name: EVENTS.PAGE_VIEW,
    page_location: window.location.href,
    // Resolved synchronously from the route table. The document.title fallback
    // can be stale for one tick after a route change (react-helmet writes
    // post-commit), but every mapped section short-circuits before the fallback.
    // Not deferred on purpose — it would reorder page_view relative to events
    // fired on mount (e.g. vendor_portal_enter).
    page_title: getSectionTitle(mode.sections, window.location.pathname) ?? document.title,
  });
}

export function useAnalyticsPageView(): void {
  const history = useHistory();
  const mode = useMode();

  useEffect(() => {
    fire(mode);
    return history.listen(() => {
      fire(mode);
    });
  }, [history, mode]);
}
